import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

interface VerifyStore {
  verification_level?: string;
  signature?: string;
  requestId?: string;
  isLoading: boolean;
}

type Actions = {
  setVerify: (data: {
    verification_level?: string;
    signature?: string;
    requestId?: string;
  }) => void;

  setLoading: (isLoading: boolean) => void;
};

export const useVerifyStore = create<VerifyStore & Actions>()(
  immer((set) => ({
    isLoading: false,
    setLoading: (isLoading) =>
      set((state) => {
        if (state.isLoading !== isLoading) {
          state.isLoading = isLoading;
        }
      }),
    setVerify: ({
      verification_level,
      signature,
      requestId,
    }: {
      verification_level?: string;
      signature?: string;
      requestId?: string;
    }) =>
      set((state) => {
        if (
          state.verification_level !== verification_level ||
          state.signature !== signature ||
          state.requestId !== requestId
        ) {
          state.verification_level = verification_level;
          state.signature = signature;
          state.requestId = requestId;
        }
      }),
  })),
);
